<section class="image-viewer" data-testid="image-viewer" tabindex="-1" #viewerRoot>
  <button
    type="button"
    class="image-viewer-close"
    data-testid="viewer-close"
    (click)="close()"
    [attr.aria-label]="'doktar_app.common.close' | translate">
    <i class="ph-bold ph-x"></i>
  </button>

  <div
    class="image-viewer-stage"
    [class.is-broken]="currentItem && (!currentItem.url || brokenImageIds.has(currentItem.id))">
    <button
      type="button"
      class="image-viewer-nav image-viewer-previous"
      data-testid="viewer-previous"
      [class.disabled]="activeIndex <= 0"
      [attr.aria-disabled]="activeIndex <= 0"
      [attr.aria-label]="'doktar_app.common.previous' | translate"
      (click)="goToPrevious()">
      <i class="ph-bold ph-caret-left"></i>
    </button>

    @if (currentItem; as item) {
      @if (item.url) {
        <img
          class="image-viewer-photo"
          [ngSrc]="item.url"
          alt=""
          fill
          priority
          (error)="markImageAsBroken(item.id)" />
      }
      @if (!item.url || brokenImageIds.has(item.id)) {
        <i class="ph-bold ph-image-broken image-viewer-broken" aria-hidden="true"></i>
      }
    }

    <button
      type="button"
      class="image-viewer-nav image-viewer-next"
      data-testid="viewer-next"
      [class.disabled]="nextDisabled"
      [attr.aria-disabled]="nextDisabled"
      [attr.aria-busy]="pendingEnd || null"
      [attr.aria-label]="'doktar_app.common.next_button' | translate"
      (click)="goToNext()">
      <i class="ph-bold ph-caret-right"></i>
    </button>
  </div>

  @if (footerTemplate && currentItem) {
    <footer class="image-viewer-footer">
      <ng-container
        [ngTemplateOutlet]="footerTemplate"
        [ngTemplateOutletContext]="{ $implicit: currentItem, index: activeIndex }" />
    </footer>
  }
</section>
